var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61101 1.17971C4.76216 0.410543 6.11553 0 7.5 0C9.35652 0 11.137 0.737498 12.4497 2.05025C13.7625 3.36301 14.5 5.14348 14.5 7C14.5 8.38447 14.0895 9.73785 13.3203 10.889C12.5511 12.0401 11.4579 12.9373 10.1788 13.4672C8.8997 13.997 7.49224 14.1356 6.13437 13.8655C4.7765 13.5954 3.52922 12.9287 2.55026 11.9497C1.57129 10.9708 0.904603 9.7235 0.634506 8.36563C0.36441 7.00776 0.503033 5.6003 1.03285 4.32122C1.56266 3.04213 2.45987 1.94888 3.61101 1.17971ZM4.16658 11.9888C5.15328 12.6481 6.31332 13 7.5 13C9.0913 13 10.6174 12.3679 11.7426 11.2426C12.8679 10.1174 13.5 8.5913 13.5 7C13.5 5.81331 13.1481 4.65327 12.4888 3.66658C11.8295 2.67988 10.8925 1.91085 9.7961 1.45672C8.69975 1.0026 7.49335 0.883777 6.32946 1.11529C5.16558 1.3468 4.09648 1.91824 3.25736 2.75736C2.41825 3.59647 1.8468 4.66557 1.61529 5.82946C1.38378 6.99334 1.5026 8.19974 1.95673 9.2961C2.41085 10.3925 3.17989 11.3295 4.16658 11.9888ZM4 7.2065L6.5 9.707L11 5.2075L10.2925 4.5L6.5 8.293L4.7065 6.5L4 7.2065Z",
    fill: "#34373F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yesIcon.1fbd093aaab6b4fcab577efd3f0a3e33.svg";
export { ForwardRef as ReactComponent };